/**
 * local-date.ts — dzisiejsza data użytkownika jako `YYYY-MM-DD`, z zegara i strefy czasowej
 * jego przeglądarki (lokalne pola daty, NIE `toISOString()`, które daje datę w UTC — tuż po
 * północy 1. dnia miesiąca w Polsce UTC wskazuje jeszcze poprzedni dzień i miesiąc).
 *
 * Konsument: wysyłka faktury do Symfonii (`clientDate` w żądaniu) — serwer używa jej jako „dziś".
 */

export function localIsoDate(date: Date = new Date()): string {
  const y = String(date.getFullYear()).padStart(4, '0');
  const m = String(date.getMonth() + 1).padStart(2, '0');
  const d = String(date.getDate()).padStart(2, '0');
  return `${y}-${m}-${d}`;
}
